import { render, staticRenderFns } from "./QRLink.vue?vue&type=template&id=64824886&scoped=true&"
import script from "./QRLink.vue?vue&type=script&lang=js&"
export * from "./QRLink.vue?vue&type=script&lang=js&"
import style0 from "./QRLink.vue?vue&type=style&index=0&id=64824886&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64824886",
  null
  
)

export default component.exports